import { type Editor } from 'grapesjs';

const UndoManagerPlugin = (editor: Editor): void => {
  editor.on('component:create', () => {
    editor.UndoManager.start();
  });

  editor.on('component:add', () => {
    editor.UndoManager.start();
  });

  editor.on('component:update', () => {
    editor.UndoManager.start();
  });

  editor.on('component:styleUpdate', () => {
    editor.UndoManager.start();
  });

  editor.on('component:clone', () => {
    editor.UndoManager.start();
  });

  editor.on('component:remove', () => {
    editor.UndoManager.start();
  });

  editor.on('component:selected', () => {
    editor.UndoManager.stop();
  });

  editor.on('component:deselected', () => {
    editor.UndoManager.stop();
  });
};

export default UndoManagerPlugin;
